var _g, _path, _path2, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#aa3369"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3 0h1.3v10.2h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4 0h1.3v10.2h-1.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 25.8c0-3.7 5-10.1 3.4-16.8c0 0-6.6 0-10.4 3.3C28.2 9 21.6 9 21.6 9C20 15.7 25 22.1 25 25.8C25 33 7.8 43.7 13 63.9c0 0 4.2-2.6 6.3-2.6c1.9 0 4.5 2.7 6.3 2.7c2.3 0 4.4-2.7 6.3-2.7c2 0 4.1 2.7 6.3 2.7c1.9 0 4.5-2.7 6.3-2.7c2.2 0 6.3 2.6 6.3 2.6C56.2 43.7 39 32.9 39 25.8",
    fill: "#e84d88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eab2bb",
    d: "M24.3 23.7h15.3v4H24.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc7ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7 41.9l-5.2 1.9s.1-14.1-3.4-18.9c-.2-.3 1.9-.9 2.2-.6c5.1 4.1 6.4 17.6 6.4 17.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 36.3l4 .9s.7-9.2 3.8-12.6c.2-.2-1.4-.5-1.7-.3c-4.3 3.1-6.1 12-6.1 12"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#eab2bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8 25.5c.6.9 2.6 3.8 2.8 6.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 30c.5-1 1.9-4.2 3.9-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7 28.8c-.9.7-3.9.7-4.9 0c-1.2-.9-1.1-4.8 0-5.8c.9-.8 4-.8 4.9 0c1.1 1 1.2 4.9 0 5.8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc7ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2 28.7c-.8.7-3.2.7-4 0c-1-.9-.9-4.6 0-5.6c.7-.8 3.3-.8 4 0c1 .9 1.1 4.7 0 5.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4 56c-2.1 0-5.1 3-7.2 3c-2.6 0-5-3-7.2-3s-4.6 3-7.2 3c-2.1 0-5.1-3-7.2-3c-1.5 0-3.9 1.1-5.5 1.9c.1 1.1.2 2.3.4 3.5c1.1-.6 4.4-2.3 6.3-2.3c2 0 4.7 2.7 6.6 2.7c2.4 0 4.6-2.7 6.6-2.7s4.3 2.7 6.6 2.7c2 0 4.7-2.7 6.6-2.7c1.9 0 5.2 1.7 6.3 2.3c.2-1.2.3-2.4.4-3.5c-1.6-.8-4-1.9-5.5-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 57.1c2.4 0 4.7-2.7 6.8-2.7c2.1 0 4.3 2.7 6.8 2.7c2 0 4.8-2.7 6.8-2.7c1.9 0 5.4 1.6 6.4 2.1V55c-1.5-.7-4.3-1.8-6-1.8c-2.1 0-4.9 2.7-7 2.7c-2.5 0-4.8-2.7-7-2.7c-2.1 0-4.5 2.7-7 2.7c-2.1 0-4.9-2.7-7-2.7c-1.7 0-4.6 1.2-6 1.8v1.5c1.1-.5 4.5-2.1 6.4-2.1c2 0 4.8 2.7 6.8 2.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDress);
export default __webpack_public_path__ + "static/media/dress.aa68df366008c14749a5111530eff66e.svg";
export { ForwardRef as ReactComponent };